import request from '@/utils/request'
import request2 from '@/utils/request2'
import request3 from '@/utils/request3'

const apis = {
  // 登录
  login(userInfo) {
    const url = 'api/account/login'
    return request({
      url: url,
      method: 'POST',
      data: userInfo,
      timeout: 30000
    })
  },
  // 登录
  bscloudlogin(token) {
    const url = 'api/account/BSCloudLogin'
    return request({
      url: url,
      method: 'POST',
      data: token,
      timeout: 30000
    })
  },
  // 确定登录
  loginConfirm() {
    const url = 'api/account/loginConfirm'
    return request({
      url: url,
      method: 'POST'
    })
  },
  // 退出登录
  logout() {
    const url = 'api/account/logout'
    return request({
      url: url,
      method: 'POST'
    })
  },
  // 修改用户状态
  changeState(state) {
    const url = 'api/account/state'
    return request({
      url: url,
      method: 'PUT',
      data: { state }
    })
  },
  // 获取结构树
  systemFrameworkFetch() {
    const url = 'api/systemFramework'
    return request({
      url: url,
      method: 'GET'
    })
  },
  // 根据通道编号获取通道信息
  gateInfoFetch(id) {
    const url = `api/systemFramework/gateInfo/${id}`
    return request({
      url: url,
      method: 'GET'
    })
  },
  // 输入车牌手动出/入场
  manualFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/enter/manual`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 获取在岗信息
  currentGateFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/gate/current`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 车牌模糊匹配
  fuzzyFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/enter/fuzzy`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 查代理图片
  imgFetch(filters) {
    const data = Object.assign({}, filters)
    const url = ` api/monitor/enter/img`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 通知监控端以 入/出 车牌为准
  modifyPlateNo(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/iorecord/plateNo`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 开闸/关闸
  barrierFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/barrier`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 长开闸
  ofenOpenFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/ofenOpen`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 修改在岗车车辆类型
  changeCarType(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/iorecord/carType`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 查询支付记录
  recentOrderFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/recentOrder`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 补缴订单查询
  runawayOrderFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/recentRunawayOrder`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 车辆信息查询
  basicFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/carInfo/basic`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 查询车辆缴费信息
  tempOrderFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/carInfo/tempOrder`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 查询车辆进出记录
  iorecordFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/carInfo/iorecord`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  shareiorecordFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/carInfo/shareiorecord`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 查询车辆通道事件
  gateEventFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/carInfo/gateEvent`
    return request({
      url: url,
      method: 'GET',
      params: data
    })
  },
  // 打印找零
  printChange(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/printChange`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  //  放行
  releaseFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/release`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  //  刷新收费信息
  onFeeFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/onFee`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 重新下发该订单
  syncOnlineOrder(data) {
    const url = `api/monitor/syncOnlineOrder`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  //  触发无牌车
  onUnlicensedFetch(filters) {
    const data = Object.assign({}, filters)
    const url = `api/monitor/onUnlicensed`
    return request({
      url: url,
      method: 'POST',
      data: data
    })
  },
  // 收费标准
  feeScaleFetch(parkId) {
    const url = `api/park/feeScale?parkId=` + parkId
    return request({
      url: url,
      method: 'GET'
    })
  },
  //  处理完成
  completeOption(completedRemarks) {
    const url = `api/mission/complete`
    return request({
      url: url,
      method: 'POST',
      data: { remark: completedRemarks }
    })
  },
  //  事件插队
  queueTop(missionId) {
    const url = `api/mission/top`
    return request({
      url: url,
      method: 'POST',
      data: { missionId }
    })
  },
  //  获取该用户所有待处理任务
  currentUserFecth() {
    const url = `api/mission/currentUser`
    return request({
      url: url,
      method: 'GET'
    })
  },
  //  通知主动事件
  activeEvent(gateId) {
    const url = `api/mission/active`
    return request({
      url: url,
      method: 'POST',
      data: { gateId }
    })
  },
  // 获取用户最近已处理任务
  recent() {
    const loginTime = sessionStorage.getItem('loginTime')
    const url = `api/mission/recent`
    return request({
      url: url,
      method: 'get',
      params: { loginTime }
    })
  },
  // 获取任务的附加信息
  getTaskExtendInfo(missionId) {
    return request({
      url: `api/mission/${missionId}/extendInfo`,
      method: 'get'
    })
  },
  sendHeartBeat() {
    return request({
      url: `api/mission/heartbeat`,
      method: 'post'
    })
  },
  // 获取乐橙云播放 kitToken
  getKitToken(deviceSN) {
    const url = `/LechangeService/OpenApi/kitToken`
    const data = { deviceId: deviceSN }

    return request2({
      url: url,
      method: 'get',
      params: data
    })
  },
  // 插入入场记录
  addEnterRecord(data) {
    const url = `api/monitor/enter`

    return request2({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 获取视频对应的mq中心
  getAnimationMQ(deviceId) {
    const url = `/AnimationService/center`
    const data = { deviceId: deviceId }

    return request2({
      url: url,
      method: 'get',
      params: data
    })
  },

  /**
   * 获取本地视频客户端的信息
   * @param {string} clientId 客户端编号
   */
  getVideoClientInfo(clientId) {
    const url = `/VideoCenter/api/client/heart`
    const params = { clientId: clientId }

    return request3({
      url: url,
      method: 'get',
      params: params
    })
  },

  /**
   * 获取一帧图片 base64 jpg
   * @param {string} url 请求地址
   */
  getVideoFrame(url) {
    // const url = `http://localhost:54310api/video/frame`

    return request3({
      url: url,
      method: 'get'
    })
  },

  getFangWeiNumber() {
    return request3({
      url: '/FangWeiAPI/Commands/PopUser',
      method: 'get'
    })
  },
  connectFangWei(data) {
    return request3({
      url: '/FangWeiAPI/Commands/connect',
      method: 'post',
      data: data
    })
  },
  disposeFangWeiNumber(data) {
    return request3({
      url: '/FangWeiAPI/Commands/dispose',
      method: 'post',
      data: data
    })
  },
  keepFangWeiAlive(number) {
    return request3({
      url: `/FangWeiAPI/Commands/heart/${number}`,
      method: 'post'
    })
  },
  getSIPNumber() {
    return request({
      url: 'api/mission/GetSIPUser',
      method: 'get'
    })
  },
  disposeSIPNumber(number,missionId) {
    return request({
      url: 'api/mission/SIPDispose',
      method: 'post',
      data: { number: number,missionId:missionId }
    })
  },
  keepSIPAlive(number) {
    return request({
      url: 'api/mission/SIPHeart',
      method: 'post',
      data: { number: number }
    })
  },
  // 根据车场编号+车牌号获取30分钟内的来访登记信息
  visitorregInfoFetch(pid,pn) {
    const url = `api/systemFramework/visitorInfo/${pid}/${pn}`
    return request({
      url: url,
      method: 'GET'
    })
  },
  visitorreg(data) {
    const url = `api/monitor/visitorreg`

    return request2({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 重新邀请设备推流（解决UDP断流后黑屏问题，后端调用wvp的play/start重新invite）
  startStream(deviceId) {
    const url = `api/stream/start`
    return request({
      url: url,
      method: 'POST',
      data: { deviceId }
    })
  }
}

export default apis



// WEBPACK FOOTER //
// ./src/api/api.js